import { render, staticRenderFns } from "./ForumIndex.vue?vue&type=template&id=5f921d58&scoped=true"
import script from "./ForumIndex.vue?vue&type=script&lang=js"
export * from "./ForumIndex.vue?vue&type=script&lang=js"
import style0 from "./ForumIndex.vue?vue&type=style&index=0&id=5f921d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f921d58",
  null
  
)

export default component.exports